import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rKiraBilgi, rValue } from '../../models/.catalog';

export default class KiraBilgiApi extends ApiBase<pList, rValue<rKiraBilgi>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/KiraBilgi',
      }),
      options
    );
  }
}
